import * as React from "react";

const IconPaginationArrowRightSmall: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="currentColor"><polygon points="12 10 0 20 0 0"/></svg>;
};

export default React.memo(IconPaginationArrowRightSmall);
